import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PanelTitle, SimpleDataList } from 'ui';
import { fetchEntities } from 'services';

export const HomeRecentRatings = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isPending, setIsPending] = useState(false);
  const [entities, setEntities] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setIsPending(true);
      const { data } = await fetchEntities({
        page: 1,
        limit: 5,
        filter: { orderByRecentRatings: true },
      });

      setEntities(
        data.map(({ id, name, industryClassification }) => ({
          id,
          primaryText: name,
          secondaryText: industryClassification,
        })),
      );
      setIsPending(false);
    };
    fetchData();
  }, []);

  const handleItemClick = ({ id }) => {
    navigate(`/entities/${id}`);
  };

  return (
    <>
      <PanelTitle>{t('Recently rated')}</PanelTitle>
      <SimpleDataList
        data={entities}
        loading={isPending}
        onItemClick={handleItemClick}
        emptyText={t('There are no ratings yet.')}
      />
    </>
  );
};
